import React from 'react';

import dayjs from 'dayjs';

import { EventLogItem, EventLogItemOperationStatus } from '@app/queryTyping';

import styles from './UserEventLogItem.pcss';

const TIME_FORMAT = 'MMM DD, YYYY hh:mm A';

const statusStyle: {
  [key in EventLogItemOperationStatus]: string;
} = {
  [EventLogItemOperationStatus.SUCCESS]: styles.titleSuccess,
  [EventLogItemOperationStatus.INFORMATION]: styles.titleSuccess,
  [EventLogItemOperationStatus.CRITICAL]: styles.titleError,
  [EventLogItemOperationStatus.ERROR]: styles.titleError,
  [EventLogItemOperationStatus.WARNING]: styles.titleError,
};

export const UserEventLogItem = React.memo<{ event: EventLogItem }>(
  ({ event }) => (
    <div className={styles.root} data-stable-name="UserEventLogItem">
      <span className={statusStyle[event.operationStatus]}>
        {`${event.eventTypeName} | ${event.description}`}
      </span>
      <time className={styles.date}>
        {dayjs(event.timestamp).utc().format(TIME_FORMAT)}
      </time>
    </div>
  ),
);
